module.exports = __webpack_public_path__ + "website/img/local-1.9af128c2.png";